import { useDispatch, useSelector } from "react-redux";
import {decrementQuantity, incrementQuantity } from "./cartSlice";

import {ReactComponent as MinusIcon} from '../../assets/images/icons/minus.svg';
import {ReactComponent as PlusIcon} from '../../assets/images/icons/plus.svg';

export const units = [
    { id: "0", name: 'шт', precision: 0 },
    { id: "1", name: 'шт', precision: 0 },
    { id: "2", name: 'кг', precision: 1 },
    { id: "3", name: 'л', precision: 1 },
    { id: "4", name: 'пач', precision: 0 },
    { id: "5", name: 'м', precision: 1 },
    { id: "6", name: 'грн', precision: 0 },
    { id: "7", name: 'год', precision: 0 },
    { id: "8", name: 'пор', precision: 0 },
    { id: "9", name: 'пляш', precision: 0 },
    { id: "10", name: 'г', precision: 2 } 
];

export const QuantitySelector = ({ id }) => {
    const item = useSelector(state => state.cart.cart).find(item => item.id === id);
    const unit = units.find(unit => unit.id === item.unit);
    const dispatch = useDispatch();

    const increment = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(incrementQuantity({ id }));
    };

    const decrement = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(decrementQuantity({ id }));
    };

    const formatQty = (qty, precision) => {
        return qty.toFixed(precision);
    };

    return (
        <div className="quantity-selector">
            <MinusIcon onClick={decrement} />
            <div onClick={(e) => { e.preventDefault(); e.stopPropagation() }} className="value">
                <span className="me-1">{item ? formatQty(item.qty, unit ? unit.precision : 0) : 1}</span>
                <span>{unit && unit.name}</span>
            </div>
            <PlusIcon onClick={increment} />
        </div>
    );
}
